import type { DroneEndpoint } from '@shared/types';

/** 无人机服务器 REST 根地址。 */
export function restBaseUrl(endpoint: DroneEndpoint): string {
  const base = endpoint.basePath.replace(/\/+$/, '');
  return `${endpoint.protocol}://${endpoint.host}:${endpoint.port}${base}`;
}

/**
 * 遥测 WebSocket 地址。
 *
 * 浏览器的 WebSocket 构造函数无法自定义请求头，因此令牌只能走查询参数 ——
 * 这也是 `docs/drone-api.md` 里要求无人机侧同时接受 `token` 查询参数的原因。
 */
export function webSocketUrl(endpoint: DroneEndpoint, token: string | null): string {
  const scheme = endpoint.protocol === 'https' ? 'wss' : 'ws';
  const path = endpoint.wsPath.startsWith('/') ? endpoint.wsPath : `/${endpoint.wsPath}`;
  const url = new URL(`${scheme}://${endpoint.host}:${endpoint.port}${path}`);
  if (token) url.searchParams.set('token', token);
  return url.toString();
}

export function endpointLabel(endpoint: DroneEndpoint): string {
  return `${endpoint.host}:${endpoint.port}${endpoint.basePath}`;
}

/**
 * 混合内容检查。
 *
 * HTTPS 页面无法连接 `http://` / `ws://` 的无人机（localhost 例外），
 * 提前拦下并给出明确原因，比让浏览器默默报错友好得多。
 */
export function mixedContentProblem(endpoint: DroneEndpoint, pageProtocol: string): string | null {
  if (pageProtocol !== 'https:') return null;
  const isLoopback =
    endpoint.host === 'localhost' || endpoint.host === '127.0.0.1' || endpoint.host === '[::1]';
  if (isLoopback) return null;
  if (endpoint.protocol !== 'https') {
    return '当前页面为 HTTPS，浏览器会拦截到明文 HTTP 无人机的连接。请为无人机服务器启用 HTTPS。';
  }
  return null;
}
